import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import {
  BrowserView,
  MobileView
} from "react-device-detect";

import videoMP4 from '../assets/bg-d.mp4';
import videoWEBm from '../assets/bg-d.webm';

import dticon from '../assets/dte-icon.svg';
import bg from '../assets/bg.gif';





class About extends Component {

  state = {
    loading: true
  };

  componentDidMount() {
    document.body.classList.remove('hide');
    setTimeout(() => this.setState({ loading: false }), 500); // simulates loading of data
  }

  
  render() {

    document.body.classList.add('hide');

    const { loading } = this.state;

    if(loading) { 
        return null; 
      }

    return (
    

      <div>
       
       <div className="px-8 md:px-16 xl:px-64 py-12 md:py-32 z-40 relative text-white">
        <Fade>
          <div>
            <h1 className="text-5xl md:text-huge-md xl:text-huge mt-16">Project(s)</h1>
          </div>
        </Fade>
        <Fade delay={300}>
          <div className="md:flex md:items-center mt-12">
            <div>
              <img src={dticon} alt="Design Token Exporter - icon" />
            </div>
            <div className="md:pl-12 mt-6 md:mt-0">
              <strong>Sketch Plugin</strong>
              <h2 className="mb-4 text-4xl">Design Token Exporter</h2>
              <p className="mb-8">Export Design Tokens from your Sketch project</p>

              <a href="https://github.com/here-erhe/Design-Token-Exporter" className="w-full md:w-auto text-center visitbtn inline-block py-4 px-12 border border-white text-white text-xl no-underline font-heading font-semibold"><span>Read more</span></a>
            </div>
          </div>
        </Fade>
      
          
      </div>

      <BrowserView>
        <div className="video-container">
          <video autoPlay loop muted>
            <source src={videoMP4} type="video/mp4" />
            <source src={videoWEBm} type="video/webm" />
          </video>
        </div>
      </BrowserView>
      <MobileView>
        <div className="video-container bg-cover bg-center" style={{backgroundImage: "url(" + bg + ")"}}>
        </div>
      </MobileView>

      </div>
    );
  }
}

export default About;





// WEBPACK FOOTER //
// ./src/pages/Projects.js